import { Result, Button } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ErrorPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const errorCode = searchParams.get('code') || '404';

    const getErrorDetails = (code: string): { status: '403' | '404' | '500' | 'error'; title: string; subTitle: string } => {
        switch (code) {
            case '403':
                return {
                    status: '403',
                    title: '403',
                    subTitle: 'Кажется вы не авторизовались',
                };
            case '500':
                return {
                    status: '500',
                    title: '500',
                    subTitle: 'Произошла ошибка. Попробуйте позже или обратитесь к Сане',
                };
            case '404':
                return {
                    status: '404',
                    title: '404',
                    subTitle: 'Страница не найдена',
                };
            default:
                return {
                    status: 'error',
                    title: 'Ошибка',
                    subTitle: 'Произошла ошибка. Попробуйте позже или обратитесь к Сане',
                };
        }
    };

    const { status, title, subTitle } = getErrorDetails(errorCode);

    return (
        <Result
            status={status}
            title={title}
            subTitle={subTitle}
            extra={
                <Button type="primary" onClick={() => navigate('/')}>
                    К странице входа
                </Button>
            }
        />
    );
};

export default ErrorPage;
